export default {
  BTN_LOGIN: "Login",
  BTN_REQ_TO_JOIN: "Request to Join",
  BTN_LOGOUT: "Log out",
  BTN_CANCEL: "Cancel",
  BTN_YES: "Yes",
  BTN_OK: "Okay",
  BTN_CREATE_EVENT: "Create",
  BTN_CONFIRM: "Confirm",
  BTN_DELETE: "Delete",
  BTN_DECLINE: "Decline",
  BTN_ACCEPT: "Accept",
  BTN_INVITE: "Invite",
  BTN_FILTER: "Filter",
  BTN_SIGNUP: "Sign up now",
  BTN_SUBMITTING: "Submitting",
  BTN_SET_PASSWORD: "Set Password",
  BTN_CREATE: "Create",
  BTN_IMPORT: "Import",
  BTN_APPROVE_ALL: "Approve all",
  BTN_ACTIVATE: "Activate",
  BTN_DEACTIVATE: "Deactivate",
  BTN_DEACTIVATE_USER: "Deactivate user",
  BTN_DELETE_USER: "Delete user",
  BTN_SEND_ACTIVATION: "Send activation",
  BTN_RESEND_LINK: "Resend Link",
  BTN_JOIN: "Join",
  BTN_ADD_PHOTOS: "Upload",
  BTN_CREATE_NEWS: "Create News",
  BTN_SEE_ALL: "see all",
  BTN_CREATE_GROUP: "Create",
  BTN_LEADERBOARD: "Leaderboard",
  BTN_SUBMIT: "Submit",
  BTN_INVITE_MEMBERS: "Invite members",
  BTN_ADD_MEMBERS: "Add members",
  BTN_FEED: "Feeds",
  BTN_NEWS: "News",
  BTN_EVENTS: "Events",
  BTN_GROUPS: "Groups",
  BTN_USERS: "Users",
  BTN_WIKI: "Wiki",
  BTN_MORE: "More",
  BTN_ASSETS: "Assets",
  BTN_DASHBOARD: "Dashboard",
  BTN_REWARDLY: "Rewardly",
  BTN_NOTIFICATION: "Notifications",
  BTN_SETTINGS: "Settings",
  BTN_ADD: "Add",
  BTN_UPDATE: "Update",
  BTN_SELECT_DATES: "Select date:",
  BTN_CLEAR_ALL: "Clear all",
  BTN_APPLY: "Apply",
  BTN_DONE: "Done",
  BTN_BACK: "Back",
  BTN_CLEAR: "Clear",
  BTN_SELECT_FILE: "Select File",
  BTN_SAVE: "Save",
  BTN_UNSAVE: "Unsave",
  BTN_DISCARD: "Discard",
  BTN_POST: "Post",
  BTN_WISH: "Wish",
  BTN_REMIND_ME: "Remind",
  BTN_RETRY: "Retry",
  BTN_CREATE_ARTICLE: "Create Article",
  BTN_OPEN_FILE: "Open File",
  BTN_DOWNLOAD: "Download",
  BTN_RESET_PASSWORD: "Reset Password",
  BTN_NO: "No",
  BTN_CHANGE: "Change",
  BTN_REMOVE: "Remove",
  BTN_ADD_MORE_FILES: "Add more files",
  BTN_EDIT: "Edit",
  BTN_SWITCH_CLUB: "Switch club",
  BTN_SWITCH_ACCOUNT: "Switch account",
  BTN_UPLOAD_LOGO: "Upload Logo",
  BTN_JOIN_GROUP: "Join group",
  BTN_LEAVE_GROUP: "Leave group",
  BTN_DELETE_GROUP: "Delete group",
  BTN_PREVIOUS: "Previous",
  BTN_CONTINUE: "Continue",
  BTN_YES_CANCEL: "Yes, cancel",
  BTN_KEEP_EDITING: "Keep editing",
  BTN_EDIT_SELECTED_GROUPS: "Edit selected Groups",
  BTN_SELECT_GROUPS: "Select Groups",
  BTN_MARK_ALL_AS_READ: "Mark all as read",
  BTN_MARK_AS_READ: "Mark as read",
  BTN_LEAVE: "Leave",
  BTN_JOIN_WAITLIST: "Join waitlist",
  BTN_LEAVE_WAITLIST: "Leave waitlist",
  BTN_UPLOAD: "Upload",
  BTN_SELECT: "Select",
  BTN_ADD_ACCOUNT: "Add account",
  BTN_CLOSE: "Close",
  BTN_LOAD_MORE: "Load more",
  BTN_TRY_AGAIN: "Try again",
  BTN_EXPORT_LIST: "Export list",
  BTN_PIN: "Pin",
  BTN_UNPIN: "Unpin",

  //LABELS
  LABEL_SENDER: "Sender",
  LABEL_RECIPIENT: "Recipient",
  LABEL_STARS_SENT: "Stars sent",
  LABEL_REWARD: "Reward",
  LABEL_REASON: "Reason",
  LABEL_DATE_SENT: "Date sent",
  LABEL_APP_NAME: "SeliseCLUB",
  LABEL_REACTIONS: "Reactions",
  LABEL_NO_USERS_YET: "No users yet",
  LABEL_NO_REACTIONS_YET: "No reactions yet",
  LABEL_CONTACT_ADMIN: "Contact your admin",
  LABEL_PENDING_ORG_ASSIGNMENT: "You haven't been added to an organization yet",
  LABEL_PENDING_ORG_ASSIGNMENT_DESC:
    "Please contact your administrator to get access. Once assigned, log in again.",
  LABEL_FILE_DOCUMENT: "Document",
  LABEL_SELISE_CLUB: "Club",
  LABEL_WELCOME_TO: "WELCOME to Selise CLUB",
  LABEL_WELOCME_TO_UAM: "Welcome to User Access Management",
  LABEL_NO_LOGO_YET: "No logo yet",
  LABEL_NEWS_CREATION: "News Creation",
  LABEL_EMAIL_PLACEHOLDER: "example@email.com",
  LABEL_NO_NOTIFCATIONS: "No notification available",
  LABEL_SIGN_IN_MICROSOFT: "Sign in with Microsoft",
  NOTIFY_BIRTHDAY_WISH:
    "🎉 {{firstName}} {{lastName}} wished you a Happy Birthday!",
  LABEL_BIRTHDAY_WISH_SENT: "Birthday wish sent to {{name}}!",
  ERROR_WISH_FAILED: "Failed to send birthday wish",
  LABEL_WELCOME: "Welcome",
  LABEL_REQUEST_JOIN: "Request to join",
  LABEL_EMAIL: "Email",
  LABEL_PASSWORD: "Password",
  LABEL_RESET_PASSOWRD: "Reset Password",
  LABEL_REMEMBER_ME: "Remember me",
  LABEL_NEW_PASSWORD: "New Password",
  LABEL_CONFIRM_PASSWORD: "Confirm Password",
  LABEL_OAUTH_DIVIDER: "Or Sign in with",
  LABEL_FIRST_NAME: "First name",
  LABEL_LAST_NAME: "Last name",
  LABEL_AUTHENTICATING: "Authenticating",
  LABEL_PASSWORD_RESET: "Your password has been set",
  LABEL_SET_NEW_PASSWORD: "Set New Password",
  LABEL_SELISE_LOGO: "SELISE Club",
  LABEL_USER_ACCESS_MANAGEMENT: "User Access Management",
  LABEL_SIGN_IN_WITH: "Or Sign in with",
  LABEL_LOGGING_IN: "Logging in...",
  LABEL_WEAK: "Weak",
  LABEL_STRONG: "Strong",
  LABEL_GOOD: "Good",
  LABEL_OKAY: "Okay",
  LABEL_CLEAR_FILTER: "Clear filters",
  LABEL_LOGOUT_CONFIRM: "Confirm logout",
  LABEL_DESC_DELETE_WIKI:
    "Deleting this article is permanent and cannot be undone. This will remove the headline, content, and all associated attachments from the platform",
  LABEL_UNKNOWN_USER: "No name",
  LABEL_REPLY: "Reply",
  //LABEL GROUPS
  LABEL_ALL_GROUPS: "All groups",
  LABEL_SAVED_GROUPS: "Saved groups",
  LABEL_SEARCH_GROUPS: "Search groups...",
  LABEL_MY_GROUPS: "My groups",
  LABEL_JOINED_GROUPS: "Joined",
  LABLE_ALL_GROUPS: "All groups",
  LABEL_VIEW_GROUP: "View",
  LABEL_START_TYPING: "Start typing here...",
  LABEL_DELETE_MEMBER: "Delete member",
  LABEL_DELETE_MEMBER_DESC: "Are you sure you want to delete this member?",
  QUEST_DELETE_MEMBER: "Delete member",
  LABEL_DESC_DELETE_MEMBER: "Are you sure you want to delete this member?",
  LABEL_GROUP_MEMBER_LIST_EMPTY: "No members yet",
  LABEL_MEMBERS_ADDED: "Members added",
  ERROR_LOADING_GROUP_MEMBERS: "Failed to load group members",
  LABEL_EMPTY_GROUP_PENDING_REQUEST: "No requests yet",
  LABEL_MENTION_USERS: "Mention users",
  // HINT
  HINT_ORG_CONFIG_REQUIRED: "Organization configuration required",
  HINT_SET_ORG_LOGO_FIRST:
    "Please set your organization logo first in the Appearance Settings before enabling the chatbot.",
  HINT_SET_NEW_PASSWORD: "Please set a new password",
  HINT_NEW_PASSWORD: "Enter your new password",
  HINT_CONFIRM_PASSWORD: "Confirm your new password",
  HINT_NOTIFIED_EMAIL: "You'll be notified by email once approved",
  HINT_NOTIFIED_EMAIL_FORGOT_PASSWORD:
    "If an account with that email exists, you'll receive a password reset link shortly",
  HINT_SIGN_IN: "Sign in to your account",
  HINT_REQUEST_DESCRIPTION:
    "Let's get you signed up so that you can access your personal account.",
  HINT_ENTER_EMAIL_BELOW: "Enter your email below to recover your password",
  HINT_CHARACTER_EIGHT: "At least 8 characters",
  HINT_CAP_LETTER_ONE: "At least 1 uppercase letter",
  HINT_ONE_NUMBER: "At least 1 number",
  HINT_SPECIAL_CHARACTER: "At least 1 special character",
  HINT_ADMIN_APPROVAL_REQUIRED: "Your account is pending admin approval",
  HINT_LOGOUT_CONFIRM: "Are you sure you want to logout?",
  HINT_PASSWORD_CHANGE_REDIRECT: "You will be send a password reset email",
  HINT_DELETE_ACCOUNT_CANNOT_UNDO:
    "Deletion of account cannot be reverted. Please consider before deletion.",
  HINT_DELETE_OWN_ACCOUNT:
    "Deleting your account cannot be undone and will remove your access to the platform immediately.",
  HINT_CONFIRMATION_TYPE_NAME: 'To confirm, type "{{name}}" in the box below',

  LABEL_FILTER: "Filter",
  LABEL_UAM_DASHBOARD: "User Management Dashboard",
  LABEL_ACTIVE_USERS: "Active users",
  LABEL_TOTAL_USERS: "Users",
  LABEL_TOTAL_ADMIN: "Admins",
  LABEL_TOTAL_MEMBERS: "Members",
  LABEL_TOTAL_POSTS: "Posts",
  LABEL_TOTAL_NEWS: "News",
  LABEL_TOTAL_EVENTS: "Events",
  LABEL_TOTAL_GROUPS: "Groups",
  LABEL_ALL_USERS: "All users",
  LABEL_SIGNUP_REQUESTS: "Sign up Requests",
  LABEL_ROLES_AND_PERMISSION: "Roles and Permission",
  LABEL_SEARCH_USERS: "Search users",
  LABEL_USERS: "Users",
  LABEL_ACCEPT: "Accept",
  LABEL_DECLINE: "Decline",
  LABEL_TO: "to",
  LABEL_NAME: "Name",
  LABEL_ROLE: "Role",
  NOTIFY_JOIN_REQUEST:
    '{{firstName}} {{lastName}} requested to join "{{groupName}}"',
  NOTIFY_ADDED_TO_GROUP:
    '{{firstName}} {{lastName}} added you to the group "{{groupName}}"',
  NOTIFY_REMOVED_FROM_GROUP:
    'You have been removed from the group "{{groupName}}"',
  LABEL_REQUEST_OR_INVITE_DATE: "Request / Invite Date",
  LABEL_ACTION: "Action",
  LABEL_STATUS: "Status",
  LABEL_DATE_JOINED: "Date Joined",
  LABEL_ACCOUNT_ACCESS: "Account Access",
  LABEL_DELETE: "Delete",
  LABEL_REMOVE: "Remove",
  LABEL_SEARCH_NEWS: "Search news",
  LABEL_LATEST_NEWS: "Latest News",
  LABEL_ALL_NEWS: "All News",
  LABEL_SAVED_NEWS: "Saved News",
  LABEL_DRAFT_NEWS: "Draft News",
  LABEL_GLOBAL_NEWS: "Selisegroup News",
  LABEL_NEWS_TITTLE: "AI Breakthrough: Machines Now Write Poetry?",
  LABEL_DESC_DEACTIVATE_ACCOUNT:
    'Deactivating this account will prevent the user from logging in. Users attempting to log in will see: "Account deactivated — contact admin." This can be reversed by reactivating the account.',
  LABEL_DESC_ACTIVATE_ACCOUNT:
    "Activating this account will restore the user's access to the platform.",
  LABEL_DESC_SEND_ACTIVATION:
    "An activation email will be sent to this user so they can set up and access their account.",
  LABEL_DESC_DELETE_ACCOUNT:
    'Deleting this account is permanent. All personal profile data will be removed. Posts and comments will remain, but the author will appear as "User". This action cannot be undone.',
  LABEL_ADMIN: "Admin",
  LABEL_IMPORT_USERS: "Import users",
  LABEL_REQUIRED_FIELDS_FOR_UPLOAD: "Required Fields for Upload",
  LABEL_ENTER_FIRST_NAME: "Enter first name",
  LABEL_PHOTOS: "Photos",
  LABEL_PHOTO: "photo",
  LABEL_NO_PHOTOS_YET: "No photos yet",
  LABEL_PHOTOS_EMPTY_DESC: "Photos from your posts will appear here",
  LABEL_LOADING: "Loading…",
  LABEL_PUBLISHING: "Publishing…",
  LABEL_PUBLISHING_PLEASE_WAIT: "Please wait, this won't take long",
  LABEL_SAVING_ARTICLE: "Saving article…",
  LABEL_MEMBER_SINCE: "Joined Since:",
  LABEL_NO_SAVED_NEWS: "No saved news found",
  LABEL_NO_DRAFTS: "No drafts found",
  LABEL_UPLOADING: "Uploading...",
  LABEL_YOU: "You",
  lABEL_POINTS: "Points",
  LABEL_RANK: "Rank",
  LABEL_POINTS: "Points",
  LABEL_POSITION: "Position",
  LABEL_ENTER_LAST_NAME: "Enter last name",
  LABEL_EMAIL_ADDRESS: "Email Address",
  LABEL_EMAIL_ADDRESS_DESC: "Email Address: Must be valid email address.",
  LABEL_ROLE_DESC: "Role (optional): Must be existing role.",
  LABEL_SELECT_EXCEL_SHEET: "Select excel sheet",
  LABEL_KB: "KB",
  LABEL_MEMBER: "Member",
  LABEL_FILES: "Files",
  LABEL_INVITE_USER: "Invite users",
  LABEL_ADDED_MEMBERS: "Added Members",
  LABEL_OR: "or",
  LABEL_USER_LIST_EMPTY: "User list is empty",
  LABEL_OPEN: "Open",
  LABEL_DOWNLOAD_TEMPLATE: "Download template",
  LABEL_FILES_COUNT: "Files",
  LABEL_FILE: "File",
  LABEL_PENDING_LIST_EMPTY: "Pending list is empty",
  LABEL_RESEND_LINK_DESC:
    "This will resend the invitation link to {{name}} via email.",
  LABEL_APPROVE_REQUEST_DESC:
    "This will approve {{name}}'s request and grant access to the platform.",
  LABEL_DECLINE_REQUEST_DESC:
    "This will decline {{name}}'s request and they will not be able to access the platform.",
  LABEL_APPROVE_ALL_DESC:
    "This will approve all pending user requests. This action cannot be undone.",
  LABEL_GENERAL: "General",
  LABEL_TOTAL: "Total",
  LABEL_ACCOUNT: "Account",
  LABEL_NOTIFICATION: "Notifications",
  LABEL_ORG_LOGO: "Organization Logo",
  LABEL_APPEARANCE: "Appearance",
  LABEL_SEARCH_SETTINGS: "Search settings",
  LABEL_NO_SETTINGS_FOUND: "No matching settings",
  LABEL_EDIT_PROFILE: "Edit Profile",
  LABEL_PERSONAL_DETAILS: "Personal Details",
  LABEL_GENDER: "Gender",
  LABEL_DOB: "Date of Birth",
  LABEL_DESCRIPTION: "Description",
  LABEL_ADDRESS: "Address",
  LABEL_COUNTRY: "Country",
  LABEL_SELECT_COUNTRY: "Select country",
  LABEL_SEARCH_COUNTRY: "Search country",
  LABEL_FILTER_BY_COUNTRY: "Filter by country",
  LABEL_ALL_COUNTRIES: "All countries",
  BTN_SELECT_ALL: "Select all",
  LABEL_ENTER_GENDER: "Enter gender",
  LABEL_DD_MM_YY: "dd/mm/yy",
  LABEL_ENTER_EMAIL: "Enter email",
  LABEL_DESCRIBE_YOURSELF: "Describe yourself",
  LABEL_ENTER_ADDRESS: "Enter address",
  LABEL_ENTER_PHONE: "Enter phone",
  LABEL_WORK_DETAILS_OPTIONAL: "Work Details (Optional)",
  LABEL_ENTER_DESIGNATION: "Enter designation",
  LABEL_ENTER_COMPANY_NAME: "Enter company name",
  LABEL_ENTER_DEPARTMENT: "Enter Department name",
  LABEL_ENTER_COMPANY_WEBSITE_URL: "Enter company website URL",
  LABEL_CHANGE_USER_DETAILS_DESC:
    "Changing user details will update the user's profile information.",
  LABEL_ACCOUNT_DELETION: "Account Deletion",
  LABEL_CLOSE_ACCOUNT: "Close Account",
  LABEL_SEARCH_FEEDS: "Search feeds",
  LABEL_THIS_ACTION_CANNOT_BE_UNDONE: "This action cannot be undone",
  LABEL_GROUP_ALL: "All",
  LABEL_GROUP_TECH: "Tech",
  LABEL_GROUP_EVENTS: "Events",
  LABEL_GROUP_CLUBS: "Clubs",
  LABEL_SHARE: "Share",
  LABEL_COMMENT: "Comment",
  LABEL_COMMENTS: "Comments",
  LABEL_SAVE: "Save",
  LABEL_SAVES: "Saves",
  LABEL_UNSAVE: "Unsave",
  LABEL_LIKE: "Like",
  LABEL_LIKES: "Likes",
  LABEL_PHONE: "Phone",
  LABEL_USER_ROLE: "User Role",
  LABEL_CHOOSE_A_ROLE_FOR_THE_USER: "Role",
  LABEL_DESIGNATION: "Designation",
  LABEL_DEPARTMENT: "Department",
  LABEL_COMPANY: "Company",
  LABEL_WEBSITE: "Website",
  LABEL_PERMISSIONS: "Permissions",
  LABEL_SHOWING: "Showing",
  LABEL_OF: "of",
  LABEL_ROLES: "Roles",
  LABEL_CREATE_ROLE: "Create role",
  LABEL_ROLE_NAME: "Role name",
  LABEL_ENTER_ROLE_NAME: "Enter role name",
  LABEL_ROLE_DESCRIPTION: "Description",
  LABEL_ENTER_ROLE_DESCRIPTION: "Enter description (optional)",
  LABEL_ROLE_SLUG: "Slug",
  SUCCESS_ROLE_CREATED: "Role created successfully",
  ERROR_ROLE_CREATED: "Failed to create role. Please try again.",
  LABEL_PROFILE_INFORMATION: "Profile Information",
  LABEL_WORK_DETAILS: "Work Details",
  LABEL_EDIT_CATEGORY: "Edit Category",
  LABEL_SELECT_FILTERS: "Select Filters",
  LABEL_ACTIVE: "Active",
  LABEL_INACTIVE: "Inactive",
  LABEL_SELECT_DATE: "Select Date:",
  LABEL_PHOTOS_COUNT: "Photos",
  LABEL_PASSWORD_AND_SECURITY: "Password and Security",
  LABEL_MODIFY_PASSWORD: "Modify Password",
  LABEL_LEADERBOARD: "Leaderboard",
  LABEL_SEE_ALL: "See all",
  LABEL_UPCOMING_EVENTS: "Upcoming Events",
  LABEL_NO_UPCOMING_EVENTS: "No upcoming events",
  LABEL_APPROVE: "Approve",
  LABEL_TRENDING_TAGS: "Trending Tags",
  LABEL_UPCOMING_BIRTHDAYS: "Upcoming Birthdays",
  LABEL_COL_RANK: "Rank",
  LABEL_COL_NAME: "Name",
  LABEL_COL_POINTS: "Points",
  LABEL_BACK: "Back",
  LABEL_NO_RESULTS: "No other available leaderboard users",
  LABEL_PTS: "Pts",
  LABEL_BADGES: "Badges",
  LABEL_SEE_ALL_TAGS: "See all tags",
  LABEL_SAVE_PERMISSIONS_DESC:
    "Saving these changes will update the role’s permissions and affect all users assigned to this role immediately.",
  LABEL_ADMIN_PERMISSION_DESC:
    "Full access to manage users, roles, permissions, and system settings. Can approve requests and control all platform data.",
  LABEL_MEMBER_PERMISSION_DESC:
    "Limited access to assigned features. Can view and manage own data but cannot change system settings or user permissions.",
  LABEL_NO_USER_DATA: "User data not available",
  LABEL_SUPER_ADMIN: "Super Admin",
  LABEL_ALL_TAGS: "All tags",
  LABEL_PENDING: "Pending",
  LABEL_EMPTY_POST: "No posts yet...",
  LABEL_NO_COMMENTS_YET: "No comments yet",
  LABEL_NO_VIEW_PERMISSION_TITLE: "Access restricted",
  LABEL_NO_VIEW_PERMISSION_DESC:
    "You don't have permission to view this. Contact your administrator if you need access.",
  LABEL_NO_SAVED_WIKI: "No saved article found matching your filters",
  LABEL_SWITCH_ACCOUNT: "Switch account",
  LABEL_ACTIVE_ACCOUNT: "Active",
  LABEL_DATE_OF_BIRTH: "Date of Birth",
  LABEL_ENTER_DATE_OF_BIRTH: "Enter date of birth",
  LABEL_NOT_AVAILABLE: "N/A",
  LABEL_USER: "User",
  LABEL_SELECT_ORGANIZATION: "Select Organization",
  LABEL_LEAVE_A_COMMENT: "Leave a comment",
  LABEL_EDIT: "Edit",
  LABEL_POSTS: "Posts",
  LABEL_SAVED: "Saved",
  LABEL_VIDEOS: "Videos",
  LABEL_REPORT: "Report",
  LABEL_SEARCH_RESULTS_FOR: "Search results for:",
  LABEL_SEE_LESS: "See less",
  LABEL_SEE_MORE: "See more",
  LABEL_NO_RESULTS_FOR: "No results for: ",
  LABEL_ARTICLES: "Articles",
  LABEL_DRAFT: "Draft",
  LABEL_SEARCH_CATEGORY: "Search category",
  LABEL_NO_ARTICLES: " No articles found",
  LABEL_NO_MORE_ARTICLES: "No more articles in this category",
  LABEL_WHATSAPP: "WhatsApp",
  LABEL_MESSENGER: "Messenger",
  LABEL_TEAMS: "Teams",
  LABEL_TELEGRAM: "Telegram",
  LABEL_ARTICLE_DETAIL: "Article Detail",
  LABEL_ATTACHMENT: "Attachment",
  LABEL_ARTICLE_CREATION: "Article Creation",
  LABEL_CATEGORY: "Category",
  LABEL_ARTICLE_COVER_IMAGE: "Article Cover Image",
  LABEL_ADD_CATEGORY: "Add Category",
  LABEL_UPLOAD_IMAGE: "Upload Image",
  LABEL_UPLOAD_OR_DRAG_DROP: "Upload files or drag and drop",
  LABEL_NEW_CATEGORY: "Add New Category",
  LABEL_CANCEL: "Cancel",
  LABEL_ADD: "Add",
  LABEL_ARTICLE_NOT_FOUND: "Article not found",
  LABEL_NO_CATEGORIES: "No categories available",
  LABEL_PREVIEW: "Preview",
  LABEL_SELECT_VISIBILITY: "Select visibility",
  LABEL_PUBLIC: "Public",
  LABEL_GROUP: "Group",
  LABEL_SPECIFIC: "Specific users",
  LABEL_PRIVATE: "Only-me",
  LABEL_SELECTED_COUNT: "{{count}} selected",
  LABEL_ITEMS_COUNT: "Total: {{count}}",
  LABEL_DATE_TBD: "Date TBD",
  LABEL_TODAY_AT: "Today at {{time}}",
  LABEL_TODAY: "Today",
  LABEL_TOMORROW_AT: "Tomorrow at {{time}}",
  LABEL_EVENT_DATE: "{{date}}",
  LABEL_NO_UPCOMING_BIRTHDAYS: "No upcoming birthdays",
  PLACEHOLDER_SEARCH_CATEGORIES: "Search categories",
  LABEL_TAGS: "Tags",
  LABEL_WIKI: "Wiki",
  LABEL_EVENTS: "Events",
  LABEL_NEWS: "News",
  LABEL_TAG: "Tag",
  LABEL_CATEGORIES: "Categories",
  LABEL_DESC_DELETE_CATEGORY: "This action cannot be undone.",
  LABEL_ARCHIVE: "Archive",
  LABEL_CREATE_GROUP: "Create",
  LABEL_EDIT_GROUP: "Edit Group",
  LABEL_JOINED: "Joined",
  LABEL_GROUP_LEFT: "Group left",
  LABEL_GROUP_DELETED: "Group deleted",
  LABEL_PENDING_APPROVAL: "Request pending",
  LABEL_REQUEST_SENT: "Request sent",
  LABEL_MEMBER_ADDED: "Member added",
  LABEL_MEMBER_REMOVED: "Member removed",
  LABEL_MEMBER_DELETE: "Delete member",
  LABEL_MEMBER_DELETE_DESC: "Are you sure you want to delete this member?",
  LABEL_SEARCH_EVENTS: "Search events",
  LABEL_EVENTS_SCREEN: "Events screen placeholder",
  LABEL_EVENT_TITLE: "Event Title",
  LABEL_SINGLE_DAY_EVENT: "Single Day Event",
  LABEL_DATE_AND_TIME: "Date and Time",
  LABEL_LOCATION: "Location",
  LABEL_COVER_IMAGE: "Cover Image",
  LABEL_JPG_PNG_UPTO_20MB: "JPG, PNG up to 20MB",
  LABEL_DETAILS: "Details",
  LABEL_NONE: "None",
  LABEL_REQUIRED: "Required",
  LABEL_INVITE_ONLY: "Invite only",
  LABEL_NO: "No",
  LABEL_YES: "Yes",
  LABEL_START_DATE: "Start Date",
  LABEL_END_DATE: "End Date",
  LABEL_START_TIME: "Start Time",
  LABEL_END_TIME: "End Time",
  LABEL_VISIBILITY_OPTIONS: "Visibility Options",
  LABEL_REGISTRATION_POLICY: "Registration Policy",
  LABEL_SETTINGS: "Settings",
  LABEL_REVIEW: "Review",
  LABEL_EVENT_CAPACITY: "Event Capacity",
  LABEL_EVENT_DETAILS: "Event Details",
  LABEL_EVENT_SETTINGS: "Event Settings",
  LABEL_PARTICIPANTS: "Participants",
  LABEL_CANCEL_EVENT_CREATION: "Cancel event creation?",
  LABEL_SELECT_TIME: "Select Time",
  LABEL_START: "Start",
  LABEL_END: "End",
  LABEL_ACTIONS: "Actions",
  // GROUPS
  LABEL_CREATE_SUB_GROUP: "Create sub-group",
  LABEL_SEARCH_POSTS: "Search posts...",
  LABEL_TAB_ABOUT: "About",
  LABEL_TAB_POSTS: "Posts",
  LABEL_TAB_MEMBERS: "Members",
  LABEL_TAB_NEWS: "News",
  LABEL_TAB_EVENTS: "Events",
  LABEL_TAB_FILES: "Files",
  LABEL_GROUP_INFORMATION: "Group information",
  LABEL_PUBLIC_GROUP: "Public group",
  LABEL_PRIVATE_GROUP: "Private group",
  LABEL_GROUP_TITLE: "Name",
  LABEL_GROUP_ADMIN: "Admin",
  LABEL_GROUP_VISIBILITY: "Visibility",
  LABEL_GROUP_DESCRIPTION: "Description",
  LABEL_SUGGESTED_GROUPS: "Suggested groups",
  LABEL_LATEST_GROUPS: "Latest groups",
  LABEL_NO_GROUPS: "No groups yet",
  LABEL_POSTS_THIS_WEEK: "posts this week",
  LABEL_TAB_ONGOING: "Ongoing",
  LABEL_TAB_UPCOMING: "Upcoming",
  LABEL_TAB_PAST: "Past",
  LABEL_TAB_MY_EVENTS: "My Events",
  LABEL_TAB_ARCHIVES: "Archives",
  LABEL_BANNERS: "Banners",
  LABEL_RIGHT_PANEL: "Right Panel",
  LABEL_CALENDAR: "Event Calendar",
  LABEL_NEXT_UP: "Next up",
  LABEL_NO_EVENTS_DESC: "There are no events to display at the moment",
  LABEL_EVENT_GALLERY: "Event Gallery",
  LABEL_PERSON_JOINED: "Person joined",
  LABEL_PEOPLE_JOINED: "People joined",
  LABEL_GOING: "People joined",
  LABEL_ABOUT_THIS_EVENT: "About this event",
  LABEL_ORGANIZER: "Organizer",
  LABEL_MORE_CATEGORIES: "More",
  LABEL_CAPACITY: "Capacity",
  LABEL_SPOTS_FILLED: "Filled",
  LABEL_FULL: "Slot full",
  LABEL_CAPACITY_COUNT: "{{attending}} / {{capacity}}",
  LABEL_SPOTS_FILLED_PERCENT: "{{percent}}% filled",
  LABEL_UNARCHIVE: "Unarchive",
  LABEL_TAB_PARTICIPANTS: "Participants",
  LABEL_SEARCH_PARTICIPANTS: "Search participants ...",
  LABEL_PARTICIPANT_COUNT: "{{count}} Participants",
  LABEL_MORE: "more",
  LABEL_PROMPT_GROUP_NAME: "Enter group name",
  LABEL_PROMPT_GROUP_DESCRIPTION: "Enter group description",
  LABEL_GROUP_COVER_PHOTO: "Group cover photo",
  LABEL_INVITE_MEMBERS: "Invite members",
  LABEL_GROUP_CREATED: "Group created",
  LABEL_GROUP_UPDATED: "Group updated",
  LABEL_CANCEL_REQUEST: "Cancel request",
  LABEL_REQUEST_CANCELLED: "Request cancelled",
  LABEL_REQUEST_REJECTED: "Request rejected",
  LABEL_LEAVE_GROUP: "Leave group",
  LABEL_DELETE_GROUP: "Delete group",
  LABEL_NOTIFY_POST_REACTION: "{{firstName}} {{lastName}} reacted to your post",
  LABEL_NOTIFY_POST_COMMENT: `{{firstName}} {{lastName}} commented on your post: "{{preview}}"`,
  LABEL_NOTIFY_POST_SHARE: "{{firstName}} {{lastName}} shared your post",

  //TEXT-EDITOT
  LABEL_LOADING_EDITOR: "Loading editor",

  //LABEL ADD MEMBERS MODAL
  LABEL_COL_EMAIL: "Email",
  LABEL_COL_GUEST: "Guest",
  LABEL_TAB_WAITLIST: "Waitlist",
  LABEL_PEOPLE_COUNT: "Select members",
  LABEL_NO_LEADERBOARD_DATA: "No leaderboard data",

  LABEL_LOCATING: "Locating",
  LABEL_DELETE_EVENT: "Delete Event",
  LABEL_STARTED_AT: "Started at {{time}}",
  LABEL_EDIT_EVENT: "Edit event",
  LABEL_CREATE_EVENT: "Create event",
  LABEL_SELECT_GROUPS: "Select Groups",
  LABEL_SEARCH: "Search",
  LABEL_GROUPS: "Groups",
  LABEL_ATTACHMENTS: "Attachments",
  LABEL_ADD_ATTACHMENTS: "Add attachments",
  LABEL_ALL: "All",
  LABEL_UNREAD: "Unread",
  LABEL_TAG_NAME: "Tags",
  LABEL_EMPLOYEES: "Employees",
  LABEL_LEGEND: "Status",
  LABEL_MALE: "Male",
  LABEL_FEMALE: "Female",
  LABEL_OTHERS: "Others",
  LABEL_UNASSIGNED: "Unassigned",
  LABEL_SWITCH_CLUB: "Switch Organization",
  LABEL_SELECT_GENDER: "Select Gender",
  LABEL_LIGHT_MODE: "Light",
  LABEL_DARK_MODE: "Dark",
  LABEL_SYSTEM: "System",
  LABEL_COLOR_MODE: "Color mode",
  LABEL_COLOR_MODE_DESC:
    "Choose if app appearance should be light or dark, or follow your computer settings",
  LABEL_PRESET_THEMES: "Preset themes",
  LABEL_PRESET_THEMES_DESC: "Choose a preset theme from our theme library",
  LABEL_CUSTOM_THEMES: "Custom theme",
  LABEL_CUSTOM_THEMES_DESC:
    "Set your own app them by changing the color for each interface element",
  LABEL_NEWS_COVER_IMAGE: "News Cover Image",
  LABEL_DESC_DELETE_NEWS:
    "Deleting this news is permanent and cannot be undone. This will remove the headline, content, and all associated attachments from the platform",
  LABEL_AUTHOR: "Author",
  LABEL_FACEBOOK: "Facebook",
  LABEL_NO_NEWS: "No news found",
  LABEL_NEWS_DETAIL: "News Detail",

  LABEL_REPLYING_TO: "Replying to",
  LABEL_USER_NO_PHOTOS: "No Photos Shared",
  LABEL_USER_PHOTOS_EMPTY_DESC:
    "This user hasn't shared any photos in their posts yet.",
  LABEL_VIDEO: "Video",
  LABEL_NO_VIDEOS_YET: "No Videos Yet",
  LABEL_VIDEOS_EMPTY_DESC: "Videos you share in your posts will appear here.",
  LABEL_USER_NO_VIDEOS: "No Videos Shared",
  LABEL_USER_VIDEOS_EMPTY_DESC:
    "This user hasn't shared any videos in their posts yet.",

  LABEL_NO_FILES: "No Files Yet",
  LABEL_NO_FILES_DESC: "Files you share in your posts will appear here.",
  LABEL_USER_NO_FILES: "No Files Shared",
  LABEL_USER_NO_FILES_DESC:
    "This user hasn't shared any files in their posts yet.",
  LABEL_LEAVE_WAITLIST_CONFIRM: "Leave Waitlist?",
  LABEL_LEAVE_EVENT_CONFIRM: "Leave Event?",
  LABEL_NO_PHOTOS_UPLOADED: "No photos uploaded",
  LABEL_SELECTED_PHOTOS: "Selected photos ({{count}})",
  LABEL_DELETE_PHOTO_CONFIRM: "Delete photo",
  LABEL_TRY_DIFFERENT_KEYWORDS: "Try different keywords",
  LABEL_LANGUAGE: "Language",
  LABEL_LANGUAGE_SETTINGS_DESC:
    "Choose your preferred language. The app will display content in the selected language.",
  LABEL_HEX: "Hex",
  LABEL_ENABLE_CHATBOT: "Enable Chatbot",
  LABEL_DISABLE_CHATBOT: "Disable Chatbot",
  LABEL_CHATBOT_GREETING:
    "My name is WikiBot. If you need any assistance or have any questions, I'm here to help.",
  LABEL_TYPE_MESSAGE: "Type a message...",
  LABEL_CHATBOT: "Wiki Chatbot",
  LABEL_NO_TITLE: "No title",
  LABEL_RESET_PASSWORD: "Reset Password",
  LABEL_PINNED_NEWS: "Pinned News",
  LABEL_NO_PINNED_NEWS: "No Pinned News",
  LABEL_PIN_NEWS: "Pin News",

  LABEL_TAB_MY_STARS: "My stars",
  LABEL_TAB_EMPLOYEE_BALANCE: "Employee balance",
  LABEL_TAB_RECOGNITIONS: "Recognitions",
  LABEL_TAB_CONFIGURE: "Configure",

  // Rewardly
  LABEL_REWARDLY_SUBTITLE: "Recognize your peers and track your rewards",
  LABEL_REWARDLY_BALANCE_SUBTITLE: "View employee balances",
  LABEL_REWARDLY_RECOGNITIONS_SUBTITLE: "View recognition records",
  LABEL_REWARDLY_CONFIGURE_SUBTITLE: "Configure reward and season settings",
  LABEL_STARS_RECEIVED_THIS_SEASON: "Stars received this season",
  LABEL_SEASON_ALLOWANCE_LEFT: "Season allowance left",
  LABEL_STARS_TO_GIVE_COLLEAGUES: "Stars to give to colleagues",
  LABEL_REWARD_AMOUNT: "Reward: {{amount}}",
  LABEL_RECOGNIZE_A_COLLEAGUE: "Recognize a colleague",
  LABEL_RECIPIENT_FIELD: "Recipient",
  LABEL_SELECT_A_COLLEAGUE: "Select a colleague...",
  LABEL_STARS_TO_GIVE: "Stars to give",
  LABEL_RECOGNITION_REASON_PLACEHOLDER: "Why are you recognizing them?",
  BTN_SEND_STARS: "Send Stars",
  LABEL_RECENT_ACTIVITY: "Recent activity",
  LABEL_NO_ACTIVITY_YET: "No activity yet this season",
  LABEL_NO_ACTIVE_SEASON: "No active season available",
  LABEL_NO_BALANCES_FOUND: "No balances found",
  LABEL_NO_RECOGNITIONS_FOUND: "No recognitions found",
  LABEL_CURRENT_SEASON: "Current season",
  LABEL_SELECT_SEASON: "Select season",
  BTN_EXPORT: "Export",
  LABEL_MONETARY_VALUE: "Monetary value",
  LABEL_RECEIVED_STARS: "Received stars",
  LABEL_ALLOWANCE_LEFT: "Allowance left",
  LABEL_SEE_REASON: "See reason",
  LABEL_SHOWING_USERS: "Showing {{from}} to {{to}} of {{total}} users",
  MSG_STARS_SENT_SUCCESS: "Stars sent successfully",
  ERROR_STARS_SEND_FAILED: "Failed to send stars. Please try again.",
  ERROR_SELECT_RECIPIENT: "Select at least one colleague to recognize",
  ERROR_INVALID_STAR_AMOUNT: "Enter a valid number of stars",
  ERROR_STARS_RANGE:
    "Stars per recognition must be between {{min}} and {{max}}",
  ERROR_REASON_REQUIRED: "Add a reason for the recognition",
  ERROR_INSUFFICIENT_ALLOWANCE:
    "Not enough allowance left to send that many stars",
  MSG_RECOGNITION_DELETED: "Recognition deleted",
  ERROR_RECOGNITION_DELETE_FAILED: "Failed to delete recognition",
  QUEST_DELETE_RECOGNITION: "Revert this recognition?",
  HINT_DELETE_RECOGNITION:
    "The sent stars will be returned and this recognition will be removed.",
  MSG_SETTINGS_SAVED: "Settings saved",
  ERROR_SETTINGS_SAVE_FAILED: "Failed to save settings. Please try again.",
  WARN_AMOUNT_POLICY_FAILED:
    "Season saved, but the send-amount limits could not be applied on the server.",
  MSG_SEASON_CREATED: "Season created successfully",
  ERROR_SEASON_CREATE_FAILED: "Failed to create season. Please try again.",
  ERROR_SEASON_NAME_EXISTS:
    "A season with this name already exists. Please choose a different name.",
  MSG_SEASON_ENDED: "Season ended successfully",
  ERROR_SEASON_END_FAILED: "Failed to end season. Please try again.",
  ERROR_USERS_ALLOCATION_FAILED:
    "{{count}} users could not receive star allocations",

  ERROR_EXPORT_FAILED: "Export failed. Please try again.",
  LABEL_SCHEDULE_SECTION: "Schedule",
  LABEL_STAR_ALLOCATION: "Star Allocation",
  LABEL_SET_STAR_EQUIVALENCE: "Set Star Reward Equivalence",
  LABEL_ONE_STAR: "1 Star",
  LABEL_SET_MONETARY_VALUE: "Set Monetary Value",
  LABEL_SET_STAR_QUANTITY: "Set Star Quantity per Recognition",
  LABEL_SET_MIN_QUANTITY: "Set Min. Quantity",
  LABEL_SET_MAX_QUANTITY: "Set Max. Quantity",
  LABEL_SET_REWARD_CURRENCY: "Set Reward Currency",
  LABEL_CURRENCY_USD: "$ USD",
  LABEL_SET_SEASON_START: "Set Season Start Time",
  HINT_SEASON_START: "The reward season will start at this date and time",
  LABEL_SET_SEASON_END: "Set Season End Time",
  HINT_SEASON_END: "The reward season will end at this date and time",
  LABEL_SET_SEASON_DATES: "Set Season Dates",
  HINT_SEASON_DATES:
    "The reward season will run between this start and end date and time",
  LABEL_SET_STARS: "Set Stars",
  LABEL_SELECT_DATE_AND_TIME: "Select date and time",
  LABEL_SEASON_NAME: "Season name",
  LABEL_ENTER_SEASON_NAME: "Enter season name",
  LABEL_EDIT_SEASON: "Edit season",
  BTN_CREATE_SEASON: "Create season",
  BTN_END_SEASON: "End season",
  LABEL_ACTIVE_SEASON_IN_PROGRESS: "Recognition season · currently in progress",
  LABEL_SEASON_STARTED: "Started",
  LABEL_TRANSACTION_STAR_RANGE: "Transaction star range",
  LABEL_ALLOWANCE: "Allowance",
  LABEL_STARS_UNIT: "stars",
  LABEL_NO_SEASON_CONFIGURE_HINT:
    "Configure and start a season to begin recognizing colleagues",
  QUEST_END_SEASON: "End this season?",
  HINT_END_SEASON:
    "Ending the season stops new recognitions and resets star allocations. This can't be undone.",
  LABEL_WORKS_AT: "Works at ",
  BTN_SAVE_DRAFT: "Save Draft",
  LABEL_NO_CATEGORIES_DESC: "No categories found",

  // HINT
  HINT_CHATBOT_DESCRIPTION:
    "Instantly access wiki-style articles, guides, and answers through an AI-powered assistant",

  HINT_ENTER_ARTICLE_TITLE: "Enter Article Title",
  HINT_ENTER_ARTICLE_CONTENT: "Enter Article Content",
  HINT_RESET_PASSWORD: "Please enter your new password to reset",
  HINT_SELECT_ORGANIZATION:
    "Please select the organization you want log in to.",

  HINT_SINGLE_DAY_EVENT: "This event will take place in one specific date only",
  HINT_SELECT_DATE_AND_TIME: "Select Date and Time",
  HINT_ENTER_EVENTS_TITLE: "Enter event title",
  HINT_ENTER_EVENT_DESCRIPTION: "Enter event description",
  HINT_DETAILS_DESCRIPTION: "Basic information about your event",
  HINT_PUBLIC_VISIBILITY: "Visible to all",
  HINT_GROUP_VISIBILITY: "Visible to group members only",
  HINT_NO_REGISTRATION: "RSVP is not required.",
  HINT_REQUIRED_REGISTRATION:
    "Participants must RSVP to attend; event capacity can be entered.",
  HINT_INVITE_ONLY: "Only invited members can participate.",
  HINT_SETTINGS_DESCRIPTION: "Choose your preferences",
  HINT_REVIEW_DESCRIPTION: "Verify and publish",
  HINT_SEARCH_LOCATION: "Search Location",
  HINT_CANCEL_EVENT_CREATION: "All your progress will be lost.",
  HINT_TAP_OR_DRAG_PIN: "Tap or drag pin",
  HINT_LOADING_FAILED: "Loading failed, please try again",
  HINT_BROWSE_BY_CATEGORY: "Browse by category",
  HINT_ARTICLE_TITLE: "Article Title",
  HINT_ARTICLE_CONTENT: "Article Content",
  HINT_OPEN_FILE_WEB: "View in a new browser tab",
  HINT_OPEN_FILE_ANDROID: "Open with another app",
  HINT_OPEN_FILE_IOS: "Open in a viewer",
  HINT_DOWNLOAD_WEB: "Save file to your computer",
  HINT_ENTER_NEWS_TITLE: "Enter your news title",
  HINT_ENTER_NEWS_CONTENT: "Enter news content or description",
  HINT_ENTER_CATEGORY_NAME: "Enter category name",
  HINT_IMAGE_ACCEPTED_FORMATS: "JPG, PNG up to 5MB",
  HINT_FILE_UPLOAD_TYPES:
    "PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, CSV, images up to 20MB",
  HINT_FILE_UPLOAD_TYPES_WIKI: "PDF, TXT up to 20MB",
  HINT_NEWS_FILTER: "No news found for the selected filters",
  HINT_PASSWORD_SET: "You can now log in with your new password",
  HINT_WIKI_FILTER: "No article found matching your filters",
  HINT_OPEN_FILE_WEB_OFFICE: "View in Google Docs in a new tab",
  HINT_SEARCH_POST: "Search post",
  HINT_CONFIRMATION_TYPE_EMAIL: "Enter: {{email}}",
  HINT_SUPER_ADMIN_CANNOT_DELETE_ACCOUNT:
    "Super admin accounts cannot be deleted",
  HINT_DOWNLOAD_ANDROID: "Save to a folder on your device",
  HINT_DOWNLOAD_IOS: "Save to Files app",
  HINT_TAP_OUTSIDE_CLOSE: "Tap outside to close",
  HINT_SPECIFIC_PEOPLE_VISIBILITY: "Only selected people can view this content",
  HINT_ONLY_ME_VISIBILITY: "Only you can view this content",
  HINT_UPLOAD_PHOTOS_TO_SEE: "Upload some pictures to see here",
  HINT_DELETE_PHOTO_CONFIRM:
    "Are you sure you want to delete this photo? This action cannot be undone.",
  HINT_LEAVE_EVENT_CONFIRM:
    "You'll be removed from this event and your spot may be taken.",
  HINT_LEAVE_WAITLIST_CONFIRM:
    "You'll lose your spot and may not get it back if the event fills up.",
  HINT_NEWS_TITLE: "News Title",
  HINT_NEWS_CONTENT: "Content",
  HINT_PIN_NEWS: "This news will be displayed at the top of the feeds.",

  // QUEST
  QUEST_DELETE_CATEGORY: "Delete {{name}}?",
  QUEST_DONT_HAVE_ACC: "Don't have an account?",
  QUEST_HAVE_ACCOUNT: "Already have an account?",
  QUEST_FORGOT_YOUR_PASSWORD: "Forgot your password?",
  QUEST_FORGOT_PASSWORD: "Forgot Password?",
  QUEST_CANCEL_NEWS_CREATION:
    "Are you sure you want to cancel? All changes will be lost.",
  QUEST_APPROVE_REQUEST: "Approve user request?",
  QUEST_DECLINE_REQUEST: "Decline user request?",
  QUEST_CONFIRM_ACTION:
    "Are you sure you want to {{action}} {{name}}'s request?",
  QUEST_DEACTIVATE_ACCOUNT: "Deactivate {{name}}'s Account?",
  QUEST_ACTIVATE_ACCOUNT: "Activate {{name}}'s Account?",
  QUEST_SEND_ACTIVATION: "Send activation email?",
  QUEST_DELETE_ACCOUNT: "Delete {{name}}'s Account Permanently?",
  QUEST_DELETE_OWN_ACCOUNT: "Delete your user account permanently?",
  QUEST_RESEND_LINK: "Resend invitation link?",
  QUEST_APPROVE_ALL_REQUESTS: "Approve all pending users?",
  QUEST_CHANGE_USER_DETAILS: "Change user details?",
  QUEST_SAVE_PERMISSIONS: "Save Permission Changes?",
  QUEST_CONFIRM_DELETE_POST: "Delete this post?",
  QUEST_CANCEL_ARTICLE_CREATION:
    "Are you sure you want to cancle article creation?",
  QUEST_WHATS_ON_YOUR_MIND: "What's on your mind?",
  QUEST_CANCEL_REQUEST: "Are you sure you want to cancel your join request?",
  QUEST_LEAVE_GROUP: "Are you sure you to leave the group?",
  QUEST_DELETE_GROUP:
    "Deleting this group will permanently remove all its members and every post shared in it. This action cannot be undone.",
  QUEST_DELETE_EVENT:
    "Are you sure you want to delete this event? This action cannot be undone.",

  // SUCCESS
  SUCCESS_CATEGORY_UPDATED: "Category updated successfully",
  SUCCESS_CATEGORY_DELETED: "Category deleted successfully",
  SUCCESS_USER_STATUS_TOGGLED: "User status updated successfully",
  SUCCESS_USER_ACTIVATION_SENT: "Activation mail sent",
  SUCCESS_USER_DEACTIVATED: "User account Deactivated",
  SUCCESS_USER_DELETED: "User deleted successfully",
  SUCCESS_USER_DECLINED: "User declined successfully",
  SUCCESS_USER_ROLE_UPDATED: "User role updated successfully",
  SUCCESS_ALL_USERS_APPROVED: "All users approved successfully",
  SUCCESS_USERS_INVITED: "Users invited successfully",
  SUCCESS_USER_ACCEPTED: "User approved successfully",
  SUCCESS_ACCOUNT_DELETED: "Your account has been deleted successfully",
  SUCCESS_ROLE_PERMISSIONS_UPDATED: "Role permissions updated successfully",
  SUCCESS_LOGIN: "You can now log into you club",
  SUCCESS_REQUEST_SUBMITTED: "Request submitted successfully",
  SUCCESS_SSO_REGISTRATION_PENDING: "SSO Registration Successful",
  SUCCESS_REGISTRATION_SUBMITTED: "Registration submitted successfully",
  SUCCESS_POST_CREATEDL: "Post created successfully",
  SUCCESS_POST_CREATED: "Post created successfully",
  SUCCESS_POST_UPDATED: "Post updated successfully",
  SUCCESS_POST_DELETED: "Post deleted successfully",
  SUCCESS_SEND_COMMENT: "Comment sent successfully",
  SUCCESS_SAVE_POST: "Post saved",
  SUCCESS_UNSAVE_POST: "Post unsaved",
  SUCCESS_EVENT_CREATED: "Event created",
  SUCCESS_EVENT_UPDATED: "Event updated",
  SUCCESS_EVENT_DELETED: "Event deleted",
  SUCCESS_PASSWORD_SET: "Your password has been set successfully",
  SUCCESS_PASSWORD_RESET: "Your password has been reset successfully",
  SUCCESS_ARTICLE_CREATED: "Article created successfully",
  SUCCESS_ARTICLE_SAVED_DRAFT: "Article draft saved successfully",
  SUCCESS_CATEGORY_CREATED: "Category created successfully",
  SUCCESS_NEWS_CREATED: "News created successfully!",
  SUCCESS_NEWS_SAVED_DRAFT: "News saved as draft successfully!",
  SUCCESS_PROFILE_UPDATED: "Profile updated successfully",
  SUCCESS_POST_SAVED: "Profile Created",
  SUCCESS_COMMENT_CREATED: "Comment sent",
  SUCCESS_CREATE_COMMENT: "Comment posted successfully!",
  SUCCESS_ARCHIVED_EVENT: "Event archived",
  SUCCESS_PHOTO_DELETE: "Photo deleted",
  SUCCESS_PHOTO_UPLOAD: "Photo uploaded",

  // ERROR
  ERROR_INVALID_REQUEST: "Invalid information",
  ERROR_NO_EMAIL: "Enter email address",
  ERROR_NAME_REQUIRED: "Name required",
  ERROR_FIRST_NAME_REQUIRED: "Please enter your name",
  ERROR_EMAIL_NOT_VALID: "Enter vaild email",
  ERROR_INVALID_EMAIL: "Enter a valid email address",
  LABEL_COPIED: "Copied to clipboard",
  ERROR_NO_PASSWORD: "Enter you password",
  ERROR_INVALID_PASSWORD_EMAIL: "Invalid email or password",
  ERROR_ACC_NOT_FOUND_OR_SERVER: "Account not found or server error",
  ERROR_PASSWORD_LENGTH: "Password must be at least 8 characters",
  ERROR_PASSWORD_CONFIRM: "Please confirm your password",
  ERROR_PASSWORD_NOT_MATCH: "Passwords do not match",
  ERROR_SSO_FAILED: "SSO login failed:",
  ERROR_GENERIC_SERVER:
    "The server encountered an error processing the request.",
  ERROR_FIRST_NAME_REQ: "Enter you first name",
  ERROR_LAST_NAME_REQ: "Enter your last name",
  ERROR_SERVER: "Server error.",
  ERROR_SUBMIT_FAILED: "Submit failed",
  ERROR_ACCOUNT_DEACTIVATED: "Your account has been deactivated",
  ERROR_ACCOUNT_PENDING: "Your account is still pending approval",
  ERROR_EMAIL_NOT_REGISTERED:
    "Invalid request. Please enter a registered email address",
  ERROR_INVALID_PASSWORD: "Invalid password",
  ERROR_NO_VALID_USER: "No valid users found in file",
  ERROR_IMPORT_FAILED: "Import failed please check file format",
  ERROR_USER_STATUS_TOGGLED: "Failed to update user status",
  ERROR_DELETE_USER: "Failed to delete user",
  ERROR_ACCEPT_USER: "Failed to approve user",
  ERROR_DECLINE_USER: "Failed to decline user",
  ERROR_APPROVE_ALL_USERS: "Failed to approve all users",
  ERROR_INVITE_USERS: "Failed to invite users",
  ERROR_UPDATE_USER_ROLE: "Failed to update user role",
  ERROR_DELETE_ACCOUNT: "Failed to delete account",
  ERROR_ROLE_PERMISSIONS_UPDATED: "Failed to update role permissions",
  ERROR_LOADING_USERS: "Error loading users",
  ERROR_CREATE_POST: "Failed to create post",
  ERROR_UPDATE_POST: "Failed to update post",
  ERROR_DELETE_POST: "Failed to delete post",
  ERROR_LOADING_POST: "Failed to load post",
  ERROR_SEND_COMMENT: "Failed to send comment",
  ERROR_SAVE_POST: "Failed to save post",
  ERROR_FAILED_TO_LOAD_COMMENTS: "Failed to load comments",
  ERROR_NEWS_LOADING: "Failed to load news",
  ERROR_LOCATION_REQUIRED: "Location required",
  ERROR_DATE_AND_TIME_REQUIRED: "Date and Time required",
  ERROR_TITLE_REQUIRED: "Title required",
  ERROR_CATEGORY_REQUIRED: "Atleast one category required",
  ERROR_EVENT_CREATION_FAILED: "Failed to create event",
  ERROR_EVENT_UPDATE_FAILED: "Failed to update event",
  ERROR_EVENT_DELETE_FAILED: "Failed to delete event",
  ERROR_NO_IMAGES_SELECTED: "Didn't pick image",
  ERROR_LOADING_EVENTS: "Failed to load events. Please try again.",
  ERROR_COULD_NOT_LOAD_PHOTOS: "Could not load photos",
  ERROR_CATEGORY_UPDATE_FAILED: "Failed to update category",
  ERROR_LOADING_CATEGORIES: "Failed to load categories",
  ERROR_CATEGORY_DELETE_FAILED: "Failed to delete category",
  ERROR_INVALID_CREDENTIALS: "Invalid credentials",
  ERROR_SWITCH_ACCOUNT_FAILED: "Failed to switch account",
  ERROR_ACCOUNT_INACTIVE_OR_UNVERIFIED:
    "Your account is inactive or not yet verified. Please contact your administrator.",

  // ERROR
  ERROR_REGISTRATION_FAILED: "Registration failed. Please try again later",
  ERROR_LOGIN_FAILED: "Login failed. Please try again later",
  ERROR_CONTENT_BLANK: "Content can't be blank",
  ERROR_HEADLINE_BLANK: "Headline can't be blank",
  ERROR_GENERIC: "An error occurred. Please try again.",
  ERROR_CATEGORY_CREATION_FAILED: "Failed to create category",
  ERROR_COVER_IMAGE_BLANK: "Please provide a cover image",
  ERROR_CATEGORY_BLANK: "Please provide a category",
  ERROR_MAX_LENGTH: "Word count should not exceed",
  ERROR_FILE_SIZE_EXCEEDED:
    "{{fileName}} is larger than {{maxSize}}MB and was skipped",
  ERROR_IMAGE_TOO_LARGE: "Image must be under {{maxSize}}MB",
  ERROR_ATTACHMENT_TOO_LARGE:
    "{{fileName}} is larger than {{maxSize}}MB and was skipped",
  ERROR_CREATE_COMMENT: "Failed to comment",
  ERROR_PROFILE_DELETE_FAILED: "Failed to Create profile",
  ERROR_COULD_NOT_LOAD_VIDEOS: "Couldn't load videos. Please try again.",
  ERROR_ARCHIVED_EVENT: "Failed to archive event",
  ERROR_SELECT_AT_LEAST_ONE_GROUP: "Select at least one group",
  ERROR_RSVP_FAILED: "Failed to join event",
  ERROR_PHOTO_DELETE: "Failed to delete photo",
  ERROR_PHOTO_UPLOAD: "Faile to upload photo",
  ERROR_SWITCH_ORG_FAILED: "Failed to switch organization",
  ERROR_EVENT_NOT_FOUND: "Event not found",
  ERROR_INVALID_IMAGE_TYPE: "Invalid image type",
  ERROR_INVALID_WIKI_ATTACHMENT_TYPE:
    "Only PDF and text files are allowed as attachments",

  TITLE_DELETE_EVENT: "Delete Event",
  DESC_DELETE_EVENT:
    "Are you sure you want to delete this event? This action cannot be undone.",
  NOTIFY_EVENT_CREATED: "{{firstName}} {{lastName}} created a new event",

  BTN_POSTING: "Posting",
  BTN_REQ_TO_JOIN_LOAD: "Requesting to Join",
  LABEL_ALMOST_FULL: "Almost full",
  LABEL_CATEGORY_NAME: "Category name",
  LABEL_DESC_DELETE_DRAFT:
    "Deleting this draft is permanent and cannot be undone. This will remove the headline, content, and all associated attachments from the platform",
  LABEL_LOAD_MORE: "Load more",
  LABEL_SENDING: "Sending...",
  LABEL_UNKNOWN_ROLE: "Unknown role",
  HINT_CONFIRMATION_DEFAULT: "Are you sure you want to proceed?",
  SUCCESS_FILE_SAVED: "{{filename}} saved successfully",
  SUCCESS_PROFILE_UPDATE: "Profile updated successfully",
  ERROR_ACCOUNT_DELETE_FAILED: "Failed to delete account",
  ERROR_ADD_ACCOUNT_FAILED: "Failed to add account",
  ERROR_CANNOT_OPEN_FILE: "Cannot open file",
  ERROR_CANNOT_OPEN_FILE_DESC: "This file could not be opened.",
  ERROR_DOWNLOAD_FAILED: "Download failed",
  ERROR_DOWNLOAD_FAILED_DESC:
    "The file could not be downloaded. Please try again.",
  ERROR_EMAIL_REQUIRED: "Email is required",
  ERROR_FORBIDDEN: "You don't have permission to perform this action",
  ERROR_IMAGE_SAVE_FAILED: "Failed to save image",
  ERROR_IMAGE_UPLOAD_FAILED: "Failed to upload image",
  ERROR_INVALID_PW_EMAIL: "Invalid email or password",
  ERROR_LAST_NAME_REQUIRED: "Last name is required",
  ERROR_LOADING_ARTICLES: "Failed to load articles",
  ERROR_LOADING_PERMISSIONS: "Failed to load permissions",
  ERROR_LOGOUT_FAILED: "Logout failed",
  ERROR_NOT_FOUND: "Account not found",
  ERROR_POST_SAVE_FAILED: "Failed to save post",
  ERROR_PROFILE_UPDATE: "Failed to update profile",
  ERROR_PROFILE_UPDATE_FAILED: "Failed to update profile",
  ERROR_SSO_AUTH_FAILED: "SSO authentication failed",
  ERROR_SSO_VALIDATION: "SSO validation failed",
};
